<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="secondary--text font-weight-medium pt-5 pb-0">
          <h3 class="mx-1 primary--text">
            {{ $t("layout.bookings") }}
          </h3>
        </v-card-title>
        <v-card-title class="secondary--text font-weight-medium pt-0">
          <v-row no-gutters class="ma-0" justify="end">
            <v-col cols="7" class="d-flex align-center">
              <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedStartDate"
                    prepend-icon=""
                    :placeholder="$t('common.DDMMYY')"
                    append-icon="mdi-calendar"
                    class="white my-2 mx-1 placeholder_as_label"
                    hide-details
                    outlined
                    flat
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedEndDate"
                    prepend-icon=""
                    :placeholder="$t('common.DDMMYY')"
                    append-icon="mdi-calendar"
                    class="mx-1 my-2 white placeholder_as_label"
                    dense
                    flat
                    outlined
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
              <v-btn
                elevation="0"
                @click="getBookingsByDate"
                color="primary"
                class="mx-1 my-2 text-none rounded-lg white--text"
              >
                {{ $t("common.search") }}
              </v-btn>
              <v-btn
                elevation="0"
                @click="clearAll"
                color="primary"
                class="mx-1 my-2 text-none rounded-lg white--text"
              >
                {{ $t("common.clear") }}
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="" v-on="on" v-bind="attrs" icon>
                    <v-icon>mdi-menu</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openRightSideDrawer">
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-plus-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="black--text">
                      {{ $t("bookings.addNew") }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-for="(item, index) in downloadList"
                    :key="index"
                    @click="exportData(item.value)"
                  >
                    <v-list-item-icon>
                      <v-icon :color="item.color">{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="black--text">{{
                      $t(item.title)
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-subtitle>
          <!-- <v-col class="d-flex justify-end">
          </v-col> -->
          <v-row class="my-2 mx-0 px-0 bg">
            <v-expansion-panels flat accordion tile>
              <v-expansion-panel>
                <v-expansion-panel-header
                  color="#f2f2f2ef"
                  class="primary--text"
                >
                  {{ $t("common.moreFilter") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#f2f2f2ef">
                  <v-row>
                    <v-col class="my-0 py-0" cols="12" lg="4" md="6" sm="6">
                      <v-select
                        v-model="paymentType"
                        outlined
                        class="white my-2"
                        hide-details
                        dense
                        :items="[
                          { text: 'All', value: 'ALL' },
                          { text: 'Pay Online', value: 'PAY_ONLINE' },
                          { text: 'Pay At Property', value: 'PAY_AT_PROPERTY' }
                        ]"
                        item-text="text"
                        item-value="value"
                        :label="$t('bookings.filterByPaymentType')"
                      ></v-select>
                    </v-col>
                    <v-col class="my-0 py-0" cols="12" lg="4" md="6" sm="6">
                      <v-autocomplete
                        v-model="landlordId"
                        outlined
                        class="white my-2"
                        hide-details
                        dense
                        :items="landlordLists"
                        item-text="user.firstName"
                        item-value="_id"
                        :label="$t('bookings.searchByLandlord')"
                      ></v-autocomplete>
                    </v-col>
                    <v-col class="my-0 py-0" cols="12" lg="4" md="6" sm="6">
                      <v-select
                        v-model="bookingStatus"
                        outlined
                        class="white my-2"
                        hide-details
                        dense
                        :items="statusItems"
                        item-text="text"
                        item-value="value"
                        :label="$t('bookings.searchStatus')"
                      ></v-select>
                    </v-col>
                    <v-col class="my-0 py-0" cols="12" lg="4" md="6" sm="6">
                      <v-autocomplete
                        :label="$t('bookings.searchByProperty')"
                        v-model="propertyId"
                        :items="filterProperties(propertyOptions)"
                        :loading="$apollo.queries.getProperties.loading"
                        :item-text="$i18n.locale === 'en' ? 'nameEn' : 'nameAr'"
                        :search-input.sync="propertySearchKey"
                        item-value="_id"
                        outlined
                        class="white my-2"
                        hide-details
                        dense
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col class="my-0 py-0" cols="12" lg="4" md="6" sm="6">
                      <v-text-field
                        :label="$t('common.searchByPhone')"
                        v-model="phone"
                        outlined
                        class="white my-2"
                        hide-details
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col class="my-0 py-0" cols="12" lg="4" md="6" sm="6">
                      <v-text-field
                        :label="$t('common.search')"
                        v-model="search"
                        outlined
                        class="white my-2"
                        hide-details
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card-subtitle>
        <!-- <div id="wrapper2">
          <div id="top-scroll" class="width-scroll-top"></div>
        </div> -->
        <v-data-table
          class="mb-9 datatable table-reference-for-scroll"
          :hide-default-footer="footer"
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          :headers="headers"
          :items="bookingLists"
          :search="search"
          id="bookingTable"
          :loading="$apollo.queries.getAllBookings.loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalBooking"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  bookingLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span class="">
              {{
                item.status === "COMPLETED"
                  ? $t("bookings.completed")
                  : item.status
              }}
            </span>
            <v-btn
              v-if="item.status === 'PAYMENT_PENDING'"
              class="custom-button text-none mx-2"
              x-small
              @click="recheckPayment(item._id)"
              depressed
            >
              <v-icon size="20" left>mdi-bookmark-check-outline</v-icon>
              Recheck
            </v-btn>
          </template>
          <template v-slot:[`item.commission`]="{ item }">
            {{
              item.property.landlord ? item.property.landlord.commission : ""
            }}
          </template>
          <template v-slot:[`item.bookingDate`]="{ item }">
            <p class="my-0 py-0">
              {{
                item.bookingDate
                  ? dateFormat(new Date(parseInt(item.bookingDate)))
                  : "-"
              }}
            </p>
          </template>
          <template v-slot:[`item.commissionToLandlord`]="{ item }">
            {{
              item.property.landlord
                ? item.property.landlord.commissionType === "FIXED"
                  ? item.property.landlord.commission
                  : (item.price * item.property.landlord.commission) / 100
                : ""
            }}
          </template>
          <template #item.isPaidAtProperty="{ item }">
            <v-btn
              @click="printInvoice(item)"
              v-if="item.isPaidAtProperty"
              icon
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <v-icon color="primary" @click="editBooking(item)"
                >mdi-pencil</v-icon
              >
              <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-row>
          </template>
          <template slot="body.append">
            <!-- v-show="isAppendBody" -->
            <tr class="">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td colspan="2" class="text-right">
                {{ $t("bookings.totalPrice") }}:
              </td>
              <td>{{ totalPrice.toFixed(3) }}</td>
              <td></td>
              <td class="text-right">{{ $t("bookings.totalCommission") }}:</td>
              <td colspan="2">{{ totalCommission.toFixed(3) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <table id="booking-pdf-table" v-show="false">
        <thead>
          <tr>
            <th>S.No</th>
            <th>
              {{ $t("bookings.customer") }}
            </th>
            <th>
              {{ $t("bookings.date") }}
            </th>
            <th>
              {{ $t("landlord.landlord") }}
            </th>
            <th>
              {{ $t("bookings.property") }}
            </th>
            <th>
              {{ $t("bookings.unit") }}
            </th>
            <th>
              {{ $t("bookings.price") }}
            </th>
            <th>
              {{ $t("landlord.commissionType") }}
            </th>
            <th>
              {{ $t("landlord.commission") }}
            </th>
            <th>
              {{ $t("bookings.commissionAmount") }}
            </th>
            <th>
              {{ $t("bookings.status") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in pdfExportList" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.customer.firstName }}</td>
            <td>
              {{
                item.bookingDate
                  ? dateFormat(new Date(parseInt(item.bookingDate)))
                  : "-"
              }}
            </td>
            <td>{{ item.property.landlord.user.firstName }}</td>
            <td>{{ item.property.nameEn }}</td>
            <td>{{ item.unit.nameEn }}</td>
            <td>{{ item.price ? item.price.toFixed(2) : "-" }}</td>
            <td>{{ item.property.landlord.commissionType }}</td>
            <td>
              {{
                item.property.landlord ? item.property.landlord.commission : ""
              }}
            </td>
            <td>
              {{
                item.property.landlord
                  ? item.property.landlord.commissionType === "FIXED"
                    ? item.property.landlord.commission.toFixed(2)
                    : (
                        (item.price * item.property.landlord.commission) /
                        100
                      ).toFixed(2)
                  : ""
              }}
            </td>
            <td>{{ item.status }}</td>
          </tr>
          <tr class="footer-data-commission">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td colspan="2" class="text-right">
              {{ $t("bookings.totalPrice") }}:
            </td>
            <td>{{ totalPrice.toFixed(3) }}</td>
            <td colspan="2" class="text-right">
              {{ $t("bookings.totalCommission") }}:
            </td>
            <td>{{ totalCommission.toFixed(3) }}</td>
          </tr>
        </tbody>
      </table>
      <side-drawer>
        <template slot="formDetails">
          <booking-form />
        </template>
      </side-drawer>
    </v-container>
  </div>
</template>

<script>
// import AddButton from "../../core/components/AddButton.vue";
import { getPaymentStatus } from "../methods/payment_status";
import { printInvoice } from "../methods/print_invoice";
import moment from "moment";
export default {
  data() {
    return {
      propertyId: "",
      downloadList: [
        {
          value: "excel",
          title: "common.excel",
          color: "success",
          icon: "mdi-application-export"
        },
        {
          value: "pdf",
          title: "common.pdf",
          color: "error",
          icon: "mdi-file-pdf-box"
        }
      ],
      propertyOptions: [],
      propertySearchKey: "",
      phone: "",
      footer: false,
      menu1: false,
      menu2: false,
      startDate: "",
      endDate: "",
      bookingStatus: "ALL",
      paymentType: "ALL",
      loading: false,
      isAppendBody: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      bookingLists: [],
      pdfExportList: [],
      totalBooking: 10,
      totalCommission: 0,
      totalPrice: 0,
      landlordLists: [],
      landlordId: null,
      formattedEndDate: "",
      formattedStartDate: ""
    };
  },
  components: {
    // "add-button": AddButton,
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "booking-form": () => import("./rightSideDrawer/BookingForm.vue")
  },
  computed: {
    statusItems() {
      return [
        {
          value: "ALL",
          text: this.$t("bookings.all")
        },
        {
          value: "REQUESTED",
          text: this.$t("bookings.requested")
        },
        {
          value: "ACCEPTED",
          text: this.$t("bookings.accepted")
        },
        {
          value: "REJECTED",
          text: this.$t("bookings.rejected")
        },
        {
          value: "PAID",
          text: this.$t("bookings.paid")
        },
        {
          value: "COMPLETED",
          text: this.$t("bookings.completed")
        },
        {
          value: "CANCELLED",
          text: this.$t("bookings.cancelled")
        },
        {
          value: "PAYMENT_PENDING",
          text: this.$t("bookings.paymentPending")
        },
        {
          value: "PAYMENT_FAILED",
          text: this.$t("bookings.paymentFailed")
        }
      ];
    },
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          width: 10
        },
        {
          text: "Ref.No",
          align: "center",
          value: "bookingReferenceId",
          width: 10
        },
        {
          text: this.$t("bookings.customer"),
          width: 80,
          value: "customer.firstName"
        },
        {
          text: this.$t("bookings.date"),
          width: 80,
          value: "bookingDate"
        },
        {
          text: this.$t("landlord.landlord"),
          width: 80,
          value: "property.landlord.user.firstName"
        },
        {
          text: this.$t("bookings.property"),
          width: 80,
          value: "property.nameEn"
        },
        {
          text: this.$t("bookings.unit"),
          width: 80,
          value: "unit.nameEn"
        },
        {
          text: this.$t("bookings.price"),
          width: 95,
          value: "price"
        },
        {
          text: this.$t("landlord.commissionType"),
          align: "d-none",
          width: 80,
          value: "property.landlord.commissionType"
        },
        {
          text: this.$t("landlord.commission"),
          width: 80,
          // align: " d-none",
          value: "commission"
        },
        {
          text: this.$t("bookings.commissionAmount"),
          // align: " d-none",
          width: 80,
          value: "commissionToLandlord"
        },
        {
          text: this.$t("bookings.status"),
          width: 80,
          value: "status"
        },
        {
          text: this.$t("bookings.downloadInvoice"),
          width: 80,
          value: "isPaidAtProperty"
        }
      ].map(header => {
        header.align = "center";
        header.sortable = false;
        return header;
      });
    }
  },
  watch: {
    startDate(val) {
      if (!val) {
        this.formattedStartDate = "";
      } else {
        this.formattedStartDate = this.dateFormat(val);
      }
    },
    endDate(val) {
      if (!val) {
        this.formattedEndDate = "";
      } else {
        this.formattedEndDate = this.dateFormat(val);
      }
    },
    propertyId() {
      this.loading = true;
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          customerName: this.search,
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        }
      });
      this.loading = false;
    },
    phone() {
      this.loading = true;
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          customerName: this.search,
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        }
      });
      this.loading = false;
    },
    landlordId(val) {
      this.loading = true;
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          customerName: this.search,
          landlordId: this.landlordId === "ALL" ? null : val,
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId,
          phone: this.phone
        }
      });
      this.loading = false;
    },
    search(val) {
      this.loading = true;
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          customerName: val,
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          customerName: this.search || "",
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        }
      });
    },
    bookingStatus(val) {
      this.loading = true;
      let filter = {};
      if (val === "ALL") {
        filter = {
          customerName: "",
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: null,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        };
      } else {
        filter = {
          customerName: "",
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: val,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        };
      }
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter
      });
      this.loading = false;
    },
    paymentType(val) {
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          customerName: this.search || "",
          paymentType: val === "ALL" ? null : val,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        }
      });
    }
  },
  apollo: {
    getProperties() {
      return {
        query: require("@/bookings/api/queries/get_properties.graphql"),
        fetchPolicy: "no-cache",
        variables: () => ({
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: this.propertySearchKey
          }
        }),
        result({ data }) {
          this.propertyOptions = data.getProperties.properties;
          this.propertyOptions.unshift({
            _id: "ALL",
            nameEn: "All",
            nameAr: "All"
          });
        }
      };
    },
    getLandlords() {
      this.loading = true;
      return {
        query: require("@/landlord/api/queries/landlord_query.graphql"),
        variables: {
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: "",
            sortBy: "",
            sortDesc: false
          }
        },
        result({ data }) {
          // , networkStatus, refetch, loading
          this.landlordLists = data.getLandlords.landlords;
          this.landlordLists.unshift({
            _id: "ALL",
            user: { firstName: "All" }
          });
        }
      };
    },
    getAllBookings() {
      this.loading = true;
      return {
        query: require("@/bookings/api/queries/booking_query.graphql"),
        fetchPolicy: "no-cache",
        variables: {
          input: {
            limit: 50,
            skip: 0
          },
          filter: {
            landlordId: this.landlordId === "ALL" ? null : this.landlordId,
            customerName: this.search || "",
            paymentType: this.paymentType === "ALL" ? null : this.paymentType,
            status: this.bookingStatus === "ALL" ? null : this.bookingStatus
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.bookingLists = this.$format.cloneVariable(
            data.getAllBookings.bookings
          );
          if (this.bookingLists.length) {
            this.totalPrice = this.bookingLists
              .map(val => val.price)
              .reduce((first, next) => {
                return first + next;
              });
            this.totalCommission = this.bookingLists
              .map(item => {
                return item.property.landlord
                  ? item.property.landlord.commissionType === "FIXED"
                    ? item.property.landlord.commission
                    : (item.price * item.property.landlord.commission) / 100
                  : 0;
              })
              .reduce((first, next) => {
                return first + next;
              });
          } else {
            this.totalPrice = 0;
            this.totalCommission = 0;
          }
          this.loading = loading;
          // console.log(this.bookingLists);
          this.totalBooking = data.getAllBookings.totalCount;
        }
      };
    }
  },
  mounted() {
    let wrapper_1 = document.querySelector(
      ".table-reference-for-scroll .v-data-table__wrapper"
    );
    let wrapper_2 = document.querySelector("#wrapper2");
    wrapper_1.onscroll = function() {
      wrapper_2.scrollLeft = wrapper_1.scrollLeft;
    };

    wrapper_2.onscroll = function() {
      wrapper_1.scrollLeft = wrapper_2.scrollLeft;
    };
    this.$root.$on("bookingsTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchBookings", () => {
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit: 50,
          skip: 0
        },
        filter: {
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          customerName: this.search || "",
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus
        }
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("bookingsTable");
  },
  methods: {
    filterProperties(properties) {
      if (this.landlordId) {
        if (properties.length) {
          if (this.landlordId === "ALL") {
            return properties;
          }
          return properties.filter(property => {
            if (property.landlord) {
              return property.landlord._id === this.landlordId;
            }
          });
        }
        return properties;
      }
      return properties;
    },
    printInvoice(booking) {
      return printInvoice(booking);
    },
    clearAll() {
      this.startDate = "";
      this.endDate = "";
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          customerName: this.search || "",
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        }
      });
      // this.$apollo.queries.getOverAllStatitics.refetch()
    },
    getBookingsByDate() {
      this.loading = true;
      this.$apollo.queries.getAllBookings.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBooking,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          landlordId: this.landlordId === "ALL" ? null : this.landlordId,
          customerName: this.search || "",
          paymentType: this.paymentType === "ALL" ? null : this.paymentType,
          status: this.bookingStatus === "ALL" ? null : this.bookingStatus,
          fromDate: this.startDate,
          toDate: this.endDate,
          phone: this.phone,
          propertyId: this.propertyId === "ALL" ? null : this.propertyId
        }
      });
      this.loading = false;
    },
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    exportData(type) {
      this.$apollo.queries.getAllBookings
        .refetch({
          input: {
            limit: 1000,
            skip: 0
          },
          filter: {
            landlordId: this.landlordId === "ALL" ? null : this.landlordId,
            customerName: this.search || null,
            paymentType: this.paymentType === "ALL" ? null : this.paymentType,
            status: this.bookingStatus === "ALL" ? null : this.bookingStatus
          }
        })
        .then(data => {
          if (type === "pdf") {
            this.pdfExportList = this.$format.cloneVariable(
              data.data.getAllBookings.bookings
            );
            setTimeout(() => {
              this.generatePdf("Booking", "booking-pdf-table");
            }, 1000);
          } else {
            this.bookingData = this.$format.cloneVariable(
              data.data.getAllBookings.bookings
            );
            this.footer = true;
            setTimeout(() => {
              this.htmlToExcel("bookingTable", "Commission");
            }, 1000);
          }
        });
    },
    recheckPayment(id) {
      const bookingId = { bookingId: id };
      getPaymentStatus(bookingId).then(data => {
        console.log(data);
      });
    },
    openRightSideDrawer() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", { dialog: true, item: item });
    },
    editBooking(item) {
      this.$store.commit("IS_EDIT_BOOKING", true);
      this.$store.commit("EDIT_BOOKING", item);
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}

/* This is the size of the path of the scrollbar */
#wrapper2 {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}

/* This div allow to make the scroll function and show the scrollbar */
#top-scroll {
  height: 1px;
  overflow: scroll;
}

/* This is the size of the scrollbar */
.width-scroll-top {
  width: 1800px;
}
</style>
